var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"course"},[_c('renderer',{attrs:{"module":_vm.stepData.module,"step":_vm.stepData.number,"stepLength":_vm.moduleData.steps.length,"markdownData":_vm.stepData.markdown}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }